<template>
    <title>Request Audit - Supplier Dashboard | Produce Mart</title>
    <dash-sidebar/>

    <section class="main_content dashboard_part large_header_bg">
        <dash-navbar/>
        <!--Main Content-->
        <div class="main_content_iner ">
            <div class="container-fluid p-0">
                <div class="row justify-content-center">
                    <!--Breadcrumb-->
                    <div class="col-12">
                        <div class="dashboard_header mb_50">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="dashboard_header_title">
                                    <h3>Request Audit</h3>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="dashboard_breadcam text-right">
                                        <p>
                                            <router-link to="/supplier-dashboard/home"><a>Dashboard</a></router-link> <i class="fas fa-caret-right"></i> Request Audit
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Request Audit-->
                    <div class="col-lg-12 certificationArea">
                        <div class="row justify-content-center">
                            <div class="col-lg-12 noteArea mb-3 mt-2">
                                <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ut quod error corrupti ratione numquam tempore voluptate provident quidem molestias velit eos dignissimos pariatur nam est.</p>
                            </div>
                            <div class="col-lg-12 mb-3">
                                <h2>Choose a certification level you would like to acquire:</h2>
                            </div>
                            <div class="col-lg-4">
                                <div class="certiBox">
                                    <img src="@/assets/img/dashboard-img/medalBronze.png">
                                    <h3>Bronze certification</h3>
                                    <div class="lineHr"></div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            $1,500
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="btnDiv text-center">
                                        <a href="#">Proceed <i class="bi bi-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="certiBox">
                                    <img src="@/assets/img/dashboard-img/medalSilver.png">
                                    <h3>Silver certification</h3>
                                    <div class="lineHr"></div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            $1,500
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="btnDiv text-center">
                                        <a href="#">Proceed <i class="bi bi-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="certiBox">
                                    <img src="@/assets/img/dashboard-img/medalGold.png">
                                    <h3>Gold certification</h3>
                                    <div class="lineHr"></div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            Amet minim mollit non deserunt ullamc.
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="detailsBoxArea">
                                        <div class="markIcon">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <div class="textSpace">
                                            $1,500
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="btnDiv text-center">
                                        <a href="#">Proceed <i class="bi bi-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Aduit Response-->
                    <div class="col-md-12">
                        <div class="white_card card_height_100 mb_30 pt-4">
                            <div class="white_card_body">
                                <div class="QA_section">
                                    <div class="white_box_tittle list_header">
                                        <h4>Audit Response</h4>
                                    </div>
                                    <div class="fileDownloadOption mb-3">
                                        <button type="button" title="Download as CSV file">CSV</button>
                                        <button type="button" title="Download as PDF file">PDF</button>
                                    </div>
                                    <div class="QA_table mb_30">
                                        <table class="table lms_table_active ">
                                            <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Certification Type</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th scope="row">1</th>
                                                <td>Gold</td>
                                                <td>Paid</td>
                                                <td>2022-04-01</td>
                                                <td><a href="#" class="status_btn">Active</a></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <dash-footer/>
    </section>
</template>
<style scoped src="@/assets/vendors/themefy_icon/themify-icons.css"></style>
<style scoped src="@/assets/vendors/niceselect/css/nice-select.css"></style>
<style scoped src="@/assets/css/style.css"></style>
<style scoped src="@/assets/css/styleSupport.css"></style>
<script>
    import DashSidebar from './dash-sidebar.vue'
    import DashNavbar from './dash-navbar.vue'
    import DashFooter from './dash-footer.vue'
    export default {
      name: "Produce Mart",
      components:{
      'dash-sidebar': DashSidebar,
      'dash-navbar': DashNavbar,
      'dash-footer': DashFooter,
      },
      mounted(){
        window.scrollTo(0,0)

        let externalScriptCustom = document.createElement('script')
        externalScriptCustom.setAttribute('src', 'https://cdn.statically.io/gh/NathTimi/Mart-script/main/custom.js')
        document.head.appendChild(externalScriptCustom)
      }
    }
</script>